/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('modules/media/channel',['require','jplayer','jquery','underscore','backbone','marionette','core/templates'],function(require) {
  'use strict';

  //////////////
  // IMPORTS //{
  //////////////

  require('jplayer');

  var $ = require('jquery');
  var _ = require('underscore');
  var Backbone = require('backbone');
  var Marionette = require('marionette');
  var templates = require('core/templates');

  /*****************************************************************************************************************///}

  var MediaChannel = Marionette.Object.extend({

  /////////////////
  // PROPERTIES //{
  /////////////////

    template: templates['modules/media/player'],

    available: false,
    queued: null,
    readyCallback: $.noop,
    holder: null,
    player: null,
    container: null,
    index: 0,
    currentMedia: null,
    suspended: false,
    paused: false,
    autonomous: true,
    radio: Backbone.Wreqr.radio.channel('global').vent,
    usedSolution: null,
    posterReady: false,
    playAttempt: 0,
    playOptions: { },
    isPlaying: false,
    forceInt: null,
    lastCC: null,

    basePath: {
      'audio': 'content/audio/',
      'video': 'content/video/'
    },

    defaults: {
      supplied: 'mp3, m4v',
      solution: 'html, flash',
      swfPath: 'content/js/',
      size: {
        width: '1012px',
        height: '650px',
        cssClass: 'jp-video-270p'
      }
    },

    autoPlay: true,

  /*****************************************************************************************************************///}

  //////////////
  // METHODS //{
  //////////////

    initialize: function(options)
    {
      //console.log('MediaChannel::initialize', options);

      if (!_.isUndefined(options.autonomous))
        this.autonomous = options.autonomous;

      options = $.extend({ }, this.defaults, options);

      this.index = options.index || 0;
      options.ready = $.proxy(this.ready, this);

      this.container = $(this.template({ id: this.index }));

      this.player = this.container.find('.player');

      this.holder = $('#media-holder');
      this.poster = this.holder.find('#media-poster');
      if (this.index === 0)
        this.container.prepend(this.poster);

      this.holder.append(this.container);

      this.buttonsHolder = this.holder.find('.jp-gui .jp-controls');
      ////console.log(this.buttonsHolder);

      this.buttonsHolder.find('.jp-play').on('click', $.proxy(this.resume, this));
      this.buttonsHolder.find('.jp-pause').on('click', $.proxy(this.suspend, this));
      this.buttonsHolder.find('.jp-replay').on('click', $.proxy(this.replay, this));

      if (this.autonomous)
        options.cssSelectorAncestor = '#' + this.container.attr('id') + ' .controls';

      this.player.jPlayer(options);
      this.hidePoster();
      this.posterReady = false;
      var self = this;
      this.poster.find('img').on('load', function(e) {
        ////console.log('poster loaded');
        self.posterReady = true;
      }).on('error', function(e) {
        ////console.log('poster fail');
        self.posterReady = false;
      });

    },

    ready: function(e)
    {
      //console.log('MediaChannel::ready');

      this.usedSolution = this.player.find('object').length > 0 ? 'flash' : 'html';
      this.player.find('video').attr('poster', 'content/graphics/invisible.png');
      this.player.find('video').attr('showlogo', 'false');

      //this.registerListeners();

      this.available = true;

      this.readyCallback(this);

      if (this.queued)
      {
        this.play(this.queued.filename, this.queued.options);
        this.queued = null;
      }
    },

    play: function(filename, options)
    {
      if (!filename) // no media specified, and no current media
      {
        //console.log('Error: No media file specified');
        return;
      }

      if (this.forceInt)
        this.clearForce('Play called');

      options = options || { };
      this.playOptions = options;
      this.playOptions.curFilename = filename;

      /*if (window.stop !== undefined)
      {
        window.stop();
      }
      else if (document.execCommand !== undefined)
      {
        document.execCommand("Stop", false);
      }*/

      if (!this.playOptions.retry)
      {
        this.cleanup(false);
        //this.off($.jPlayer.event.ended);
        //console.log('hide poster in play');
        this.hidePoster();
        this.registerListeners();
        //this.container.show();
        this.playAttempt = 1;
      }

      //console.log('channel play', options);
      if (options.showBtns !== true)
      {
        this.buttonsHolder.hide();
      }
      else
      {
        this.buttonsHolder.find('.jp-play').hide();
        this.buttonsHolder.find('.jp-pause').show();
        this.buttonsHolder.show();
      }

      if (_.isUndefined(options.autoPlay))
        options.autoPlay = true;

      if (!this.available)
      {
        console.warn('Media not available yet, queueing playback...');
        this.queued = { filename: filename, options: options };
        return;
      }

      if (!this.autonomous)
        this.radio.trigger('ui.update', { play: true, pause: true });

      //this.available = false;

      //console.log('Playing media: ', arguments);

      var media = { };

      this.currentMedia = filename;
      this.mediaType = this.getMediaType(filename);

      var path = options.customPathing || this.basePath[this.mediaType];

      if (this.mediaType === 'video') // video
      {
        media.m4v = path + filename;
        //this.container.removeClass('disguise');
        this.poster.find('img').attr('src', 'content/graphics/' + filename.split('.')[0] + '.jpg');
        //media.poster = 'content/graphics/' + filename.split('.')[0] + '.jpg';
      }
      else if (this.mediaType === 'audio') // audio
      {
        media.mp3 = path + filename;
        this.container.addClass('disguise');
      }
      else
      {
        console.error('Error: Media type unknown [' + this.mediaType + ']');
        return;
      }

      if (!this.autonomous)
        this.setCaption(options.caption);

      media.title = options.title || '';

      this.player.jPlayer('setMedia', media);
      //this.player.css('left', 10000);

      if (this.mediaType === 'video' && this.usedSolution === 'html') // video
      {
        if (options.controls)
          this.player.find('video').attr('controls', true);
        else
          this.player.find('video').removeAttr('controls');

        this.container.find('.subtitle-text').html(options.subtitle || '');
      }

      if (filename)
        this.container.attr('data-file', filename.split('.')[0]);

      if (this.usedSolution === 'html')
      {
        if (options.playbackRate)
        {
          this.player.find('video')[0].playbackRate = options.playbackRate;
          this.player.find('audio')[0].playbackRate = options.playbackRate;
        }
        else
        {
          this.player.find('video')[0].playbackRate = 1;
          this.player.find('audio')[0].playbackRate = 1;
        }
      }

      //this.hidePoster();

      if (options.loop)
        this.player.on($.jPlayer.event.ended, $.proxy(this.loop, this));
      else if (this.index !== 0)
        this.player.off($.jPlayer.event.ended, $.proxy(this.loop, this));

      if (options.autoPlay)
      {
        console.warn('autoplay the media', this.usedSolution);
        var self = this;
        if (this.usedSolution === 'flash')
          self.player.jPlayer('play');
        else
        {
          try {
            console.log('trying auto play');
            this.player.jPlayer('play');
          }
          catch (err) {
            console.error('error on autoplay', err);
            this.player.on($.jPlayer.event.loadedmetadata, function() {
              self.player.jPlayer('play');
            });
          }
        }
        //this.player.jPlayer('play', 0.01);
      }
    },

    loop: function(e)
    {
      this.player.jPlayer('play');
    },

    pause: function()
    {
      //console.log('channel pause');
      this.player.jPlayer('pause');
    },

    stop: function()
    {
      this.player.jPlayer('stop');
    },

    togglePause: function()
    {
      if (!this.player.data('jPlayer').status.paused)
      {
        //console.log('TOGGLE PAUSE');
        this.cheatPause = true;
        this.pause();
      }
      else
      {
        //console.log('TOGGLE PLAY');
        this.cheatPause = false;
        this.player.jPlayer('play');
      }
    },

    toggleMute: function(value)
    {
      if (value)
        this.player.jPlayer('mute');
      else
        this.player.jPlayer('unmute');
    },

    isMuted: function()
    {
      return this.player.jPlayer('option', 'muted');
    },

    seekTo: function(percent)
    {
      this.player.jPlayer('playHead', percent);
    },

    lockSeek: function()
    {
      this.container.find('.jp-progress').addClass('locked');
    },

    unlockSeek: function()
    {
      this.container.find('.jp-progress').removeClass('locked');
    },

    suspend: function()
    {
      if (!this.suspended)
      {
        this.suspended = true;

        if (!this.player.data('jPlayer').status.paused)
          this.player.jPlayer('pause');

        this.paused = true;
      }
    },

    resume: function(force)
    {
      if (this.suspended || force)
      {
        this.suspended = false;

        if (this.paused)
        {
          this.player.jPlayer('play');
        }
        this.hidePoster();
      }
    },

    replay: function()
    {
      this.seekTo(0);
      this.resume(true);
    },

    skip: function()
    {
      this.stop();
      this.player.trigger($.jPlayer.event.ended);
    },

    setCaption: function(caption)
    {
      //console.log('Channel::setCaption', caption);
      this.clearCC();
      if (!caption)
        return;

      var data = { };

      if (_.isString(caption))
      {
        data.character = 'Narrator';
        data.text = caption;
      }
      else if (_.isPlainObject(caption) || _.isArray(caption))
      {
        if (_.isArray(caption) || (caption && caption.text && _.isArray(caption.text)))
        {
          data.character = false;
          var _arr = _.isArray(caption) ? caption : caption.text;
          ////console.log('arr', _arr);
          _.each(_arr, function($line) {
            ////console.log('line', $line);
            if (!data.text)
              data.text = '';
            else
              data.text = data.text + '<br />';

            data.text = data.text + '<span class="character">' + $line.character + '</span> ' + $line.caption;
          }, this);
        }
        else
        {
          data.character = caption.character || 'Narrator';
          data.text = caption.text;
        }
      }
      else
      {
        //data = { character: null, text: 'No caption.' };
        data = { character: null, text: '' };
      }

      var rendered;

      try
      {
        var captionTmpl = templates['modules/media/caption'];
        rendered = captionTmpl(data);
      }
      catch (err)
      {
        console.error('Warning: Invalid JSON format detected.', err);
        rendered = 'No caption.';
      }

      //console.log('channel render');
      this.radio.trigger('render.caption', rendered);
      // $('#caption-holder #caption-contents').html(rendered);
      // if (popWin && popWin.setCaption)
      //   popWin.setCaption(rendered);
    },

    getMediaType: function(filename)
    {
      if (filename.indexOf('.mp3') >= 0)
        return 'audio';
      else if (filename.indexOf('.mp4') >= 0)
        return 'video';
      else
        return 'unknown';
    },

    showPoster: function()
    {
      //console.log('show poster', this.player.find('img').get(0).complete);
      var img = this.poster.find('img').get(0);
      if (img && this.posterReady)
      {
        this.poster.show();
        this.buttonsHolder.find('.jp-replay').show();
        this.buttonsHolder.find('.jp-play').addClass('replay-shown');
        //this.player.find('img').show();
      }
    },

    hidePoster: function()
    {
      //alert('hide poster');
      ////console.log('hide poster');
      //this.player.find('img').hide();
      if (this.index === 0)
      {
        this.poster.hide();
        this.buttonsHolder.find('.jp-replay').hide();
        this.buttonsHolder.find('.jp-play').removeClass('replay-shown');
      }
    },

    cleanup: function(__clearMedia)
    {
      __clearMedia = __clearMedia === undefined ? true : __clearMedia;
      ////console.log('Channel::cleanup');
      this.clearForce('Cleanup');

      this.unregisterListeners();
      this.player.jPlayer('pause');
      this.isPlaying = false;
      this.clearCC();
      //this.container.hide();
      var self = this;
      var lastSrc = this.playOptions.curFilename;

      if (this.mediaType === 'video')
      {
        _.delay(function() {
          //console.log('disguise delay', __clearMedia, self.isPlaying, self.playOptions.curFilename, self.mediaType);
          if (__clearMedia && ((!self.isPlaying && self.playOptions.curFilename === lastSrc) || self.mediaType === 'audio'))
          {
            self.addDisguise();
          }
        }, 500);

        _.delay(function() {
          if (__clearMedia && !self.isPlaying && self.playOptions.curFilename === lastSrc)
          {
            //console.log('clear media');
            self.player.jPlayer('clearMedia');
            self.poster.find('img').attr('src', '');
          }
        }, 1000);

      }
      else if (__clearMedia)
      {
        this.addDisguise();
        self.player.jPlayer('clearMedia');
        self.poster.find('img').attr('src', '');
      }

      //this.player.unbind($.jPlayer.event.ended);

      this.available = true;
      this.suspended = false;

      //this.endedHandler = this.channelEnded;

      if (!this.autonomous)
      {
        this.radio.trigger('ui.update', { play: false, pause: false });
        this.setCaption();
      }
    },

    addDisguise: function()
    {
      //alert('disguise');
      //console.log('add disguise');
      this.container.addClass('disguise');
      //this.poster.addClass('disguise');
    },

    removeDisguise: function()
    {
      //console.log('remove disguise');
      this.container.removeClass('disguise');
      //this.poster.removeClass('disguise');
    },

    destroy: function()
    {
      ////console.log('Channel::destroy');

      this.unregisterListeners();

      this.player.jPlayer('destroy');
      this.container.remove();
    },

    registerListeners: function(func, context)
    {
      this.unregisterListeners(func, context);
      func = func || this.eventHandler;
      context = context || this;
      ////this.radio.trigger('achievement.show', {title: 'registerListeners'});
      //alert('registerListeners');
      for (var id in $.jPlayer.event)
      {
        this.player.on($.jPlayer.event[id], $.proxy(func, context, id));
      }
    },

    unregisterListeners: function(func, context)
    {
      func = func || this.eventHandler;
      context = context || this;

      ////this.radio.trigger('achievement.show', {title: 'unregisterListeners'});
      //alert('unregisterListeners');
      for (var id in $.jPlayer.event)
      {
        if (this.player)
          this.player.off($.jPlayer.event[id], $.proxy(func, context));
      }
    },

    eventHandler: function(id, e)
    {
      ////console.log('MediaPlayer::eventHandler');
      ////console.log(this[id + 'Handler'], arguments);
      if (this[id + 'Handler'])
        this[id + 'Handler'](e);

      this.trigger('channel.' + id);
    },

    playHandler: function(e)
    {
      this.paused = false;
      this.resume();
      this.buttonsHolder.find('.jp-play').hide();
      this.buttonsHolder.find('.jp-pause').show();

      this.player.css('left', 0);

      if (this.usedSolution === 'flash')
        _.delay($.proxy(this.playingHandler, this, e), 250);
    },

    canplayHandler: function(e)
    {
      //console.log('can play handler');
    },

    timeupdateHandler: function(e)
    {
      ////console.log('time update', e);
      if (this.forceInt)
        this.clearForce('Timeupdate');

      if (this.mediaType === 'video' && this.isPlaying)
      {
        //console.log('hide poster in timeupdate');
        if (this.container.hasClass('disguise') && e.jPlayer.status.currentTime !== 0)
        {
          this.hidePoster();
          this.removeDisguise();
        }

        if (e.jPlayer && e.jPlayer.status && e.jPlayer.status.remaining < 0.5)
        {
          this.showPoster();
        }
        //console.log(e);
      }

      this.updateAudioProgress(e);

      if (this.isPlaying && this.mediaType === 'video')
        this.checkCC(e);
    },

    updateAudioProgress: function(e)
    {
      //audio_mc, skip_audio_mc, activity_skip_mc
      var $audioEl = $('[data-mc=audio_mc], [data-mc=skip_audio_mc], [data-mc=activity_skip_mc]');
      if ($audioEl.length === 0 || this.index !== 0)
        return;

      var _perc = Math.round(e.jPlayer.status.currentPercentAbsolute);
      var _5base = Math.round(_perc / 5) * 5;
      $audioEl.attr('data-perc', _5base);

      $audioEl.find('[data-mc=progress-bar]').css('width', _perc + '%');
      //var $audioDiv = this.player[0].getElementsByTagName('audio');
      ////console.log('audio progress', e.jPlayer.status);
      //$curTime = e.jPlayer.status.currentTime;
    },

    checkCC: function(e)
    {
      if (!this.playOptions.cc || this.index !== 0)
        return;

      var $videoDiv = this.player[0].getElementsByTagName('video');
      var $ccDiv = this.player.siblings('.jp-video-captions');
      ////console.log('div', $ccDiv);
      var $curTime = 0;
      if ($videoDiv.length > 0)
        $curTime = $videoDiv[0].currentTime;
      else
        $curTime = e.jPlayer.status.currentTime;

      ////console.log('check cc:', $curTime, this.playOptions);
      var _char = $('<span>');//$('<div>').addClass('cc-char');//'<div class="cc-char">character</div>';
      var _text = $('<span>');//$('<div>').addClass('cc-text');//'<div class="cc-text">text here</div>';

      _.forEachRight(this.playOptions.cc, function(_cc) {
        if ($curTime >= _cc.time)
        {
          ////console.log('match', _cc.character, _cc.caption);
          _char = $('<div>').addClass('cc-char').html(_cc.character);
          _text = $('<div>').addClass('cc-text').html(_cc.caption);
          return false;
        }
      });

      this.radio.trigger('render.cc', $ccDiv, _char, _text, $curTime);
    },

    clearCC: function()
    {
      var $ccDiv = this.player.siblings('.jp-video-captions');
      this.radio.trigger('clear.cc', $ccDiv);
      this.lastCC = null;
    },

    playingHandler: function(e)
    {
      if (navigator.userAgent.toLowerCase().indexOf('android') === -1)
      {
        clearTimeout(this.forceInt);
        this.forceInt = _.delay($.proxy(this.forcePlay, this), 900);
      }

      //console.log('playing handler');
      this.registerListeners();
      this.isPlaying = true;
      this.isEnded = false;
      if (this.mediaType === 'video')
      {
        //this.hidePoster();
        //this.removeDisguise();
      }
    },

    forcePlay: function()
    {
      console.warn('Force playing');
      this.forceInt = null;
      this.pause();
      this.resume();
    },

    clearForce: function(_reason)
    {
      console.warn('Clear force:', _reason);
      clearTimeout(this.forceInt);
      this.forceInt = null;
    },

    errorHandler: function(e)
    {
      var self = this;
      this.status = 'error';
      //alert('jplayer error - ' + e.jPlayer.error.type);
      //this.radio.trigger('achievement.show', {title: e.jPlayer.error.type + ' - ' + $.jPlayer.error.URL});
      //return;
      console.error('JPlayer Error: ', e.jPlayer.error, e);

      if (e.jPlayer.error.type === 'e_no_solution')
      {
        //console.log('This course requires Flash Player 10.1 or later. Some items may be disabled.', 1);
        this.available = false;
      }
      else if (this.playAttempt < 2 && this.playOptions)
      {
        this.playAttempt++;
        this.playOptions.retry = true;
        this.radio.trigger('check.connection');
        console.warn('Retry play attempt and check Conn (op, attempt)', this.playOptions, this.playAttempt);
        _.delay(function() {
          console.warn('Retrying...');
          if (self.isPlaying)
          {
            console.warn('Already playing, abort.');
            return;
          }
          //this.radio.trigger('achievement.show', {title: 'retry play'});
          console.warn('Calling Play.');
          var d = new Date();
          self.play(self.playOptions.curFilename + '?rand=' + d.getTime(), self.playOptions);
        }, 1500);
        //this.play(this.playOptions.curFilename, this.playOptions);
      }
      else // try to load some placeholder media instead
      {
        if (e.jPlayer.error.context.indexOf('placeholder') >= 0 || e.jPlayer.error.context.indexOf('video_enable') >= 0) // already tried placeholder
        {
          //console.log('Failed to load placeholder media.');
          console.error('Failed to load media and placeholder. Aborting play and triggering endedHandler.');
          this.endedHandler(e);
          return;
        }
        else if (e.jPlayer.error.context.indexOf('.m4v') >= 0 || e.jPlayer.error.context.indexOf('.mp4') >= 0) // is video
        {
          console.warn('Playing placeholder Video');
          this.playOptions.available = true;
          this.play('video_enable.mp4', this.playOptions);
        }
        else if (e.jPlayer.error.context.indexOf('.mp3') >= 0) // is audio
        {
          console.warn('Playing placeholder Audio');
          this.playOptions.available = true;
          this.play('placeholder.mp3', this.playOptions);
        }
      }
    },

    pauseHandler: function(e)
    {
      if (this.mediaType === 'video')
      {
        this.buttonsHolder.find('.jp-play').show();
        this.buttonsHolder.find('.jp-pause').hide();
        this.suspend();
      }
      else
      {
        var self = this;
        _.defer(function() {
          if (!self.cheatPause && !self.isEnded)
          {
            //self.radio.trigger('achievement.show', {title: 'pause ended'});
            self.endedHandler(e);
          }
        });
      }
    },

    endedHandler: function(e)
    {
      //alert('channel.endedHandler');
      this.isPlaying = false;
      if (!this.isEnded)
      {
        this.isEnded = true;
        //this.radio.trigger('achievement.show', {title: 'channel.endedHandler'});
        this.channelEnded(e);
        this.trigger($.jPlayer.event.ended);
      }
      //alert('ended');
      //this.seekTo(100);
      //this.available = true;
      //alert('ended');
    },

    channelEnded: function(e)
    {
      //alert('channel.channelEnded');
      ////this.radio.trigger('achievement.show', {title: 'channel.channelEnded'});
      console.warn('Channel ended handler');
      if (this.mediaType === 'video')
      {
        this.showPoster();
        this.clearCC();
        this.seekTo(100);
      }
    }

    /*****************************************************************************************************************///}

  });

  return MediaChannel;

});

